import React from 'react'
import CustomTabs from '../../components/DefaultTabs/CustomTabs'
import { LeadManagementIcon, AllLeadsIcon } from "../../utils/svgIcons";
import DefaultTableLayout from '../../components/DefaultTableLayout/DefaultTableLayout';
import { useAuth } from '../../hooks/useAuth';



function Index() {
  const { user } = useAuth();
  const adminType = user?.type;
  const tabs = [
    {
      key: "TpLeads",
      title: "Leads",
      icon: <LeadManagementIcon />,
    },
    ...(adminType === "SUPER"
      ? [{
        key: "TPUsers",
        title: "TP Users",
        icon: <AllLeadsIcon />,
      }]
      : []),
  ];
  return (
    <CustomTabs default={"TpLeads"} tabs={tabs} />
  )
}

export default Index;